import { countDecimals } from './numberHelpers';

const getValidatedPriceInput = (newUserInput, previousUserInput, { zeroReplacement = 0, allowDecimals = true, maxDecimals = 2 }) => {
	let newValue = String(newUserInput).replace(' ', '');

	if (newValue === '.') {
		return '0.';
	}

	if (allowDecimals) {
		newValue = newValue.replace(',', '.');
		newValue = newValue.replace('..', '.');

		if ((newValue.match(/\./g) || []).length > 1) {
			return previousUserInput;
		}
	} else {
		newValue = newValue.replace(',', '');
		newValue = newValue.replace('.', '');
	}

	if (newValue.startsWith('0') && !newValue.startsWith('0.') && newValue.length > 1) {
		newValue = newValue.substring(1);
	}

	if (newValue === '') {
		return '';
	}

	const decimalsThreshold = maxDecimals + 1;
	let endString = '';
	for (let index = 0; index < decimalsThreshold; index += 1) {
		endString += '0';
	}

	if (
		/^[0-9.]+$/gm.test(newValue) &&
		countDecimals(newValue) < decimalsThreshold &&
		(!newValue.includes('.') || !newValue.endsWith(endString))
	) {
		if (parseFloat(newValue) <= 0 && !newValue.includes('.')) {
			newValue = zeroReplacement;
		}
		return newValue;
	}

	return previousUserInput;
};

const convertEuroToCent = (euroPrice, fallbackCentPrice = 0) => {
	let centPrice = 0;
	if (typeof euroPrice === 'undefined' || euroPrice === '') {
		centPrice = fallbackCentPrice;
	} else if (String(euroPrice).includes('.')) {
		centPrice = parseInt(String(parseFloat(euroPrice).toFixed(2)).replace('.', ''));
	} else {
		centPrice = parseInt(euroPrice) * 100;
	}

	return centPrice;
};

export { getValidatedPriceInput, convertEuroToCent };
